import { render, staticRenderFns } from "./confirmForm.vue?vue&type=template&id=2ba9a845&scoped=true&"
import script from "./confirmForm.vue?vue&type=script&lang=js&"
export * from "./confirmForm.vue?vue&type=script&lang=js&"
import style0 from "./confirmForm.vue?vue&type=style&index=0&id=2ba9a845&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9a845",
  null
  
)

export default component.exports